import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend({
  normalizeArrayResponse(store, primaryModelClass, payload, id, requestType) {
    const newPayload = payload.partner_application_categories;
    return this._super(store, primaryModelClass, newPayload, id, requestType);
  }
});